import React from "react";

const FinancingSection = () => {
  return (
    <div className="container py-5">
      <div className="row">

        {/* Colonne gauche : Plans de financement */}
        <div className="col-md-6">
          <h2 className="fw-bold mb-4">Plans de financement par un OPCO</h2>
          <p>
            Nos formations peuvent être financées en totalité ou en partie par différents dispositifs d’aide, accessibles au niveau national ou régional.
          </p>
          <p>
            Nos conseillers vous accompagnent dans le montage et le dépôt de votre demande de financement pour maximiser vos chances d’obtenir les subventions auxquelles vous êtes éligible.
          </p>
          <p>
            En fonction de votre situation, plusieurs financements sont possibles : <strong>Plan de Formation</strong>, <strong>Compte Personnel de Formation (CPF)</strong>, ou autres subventions adaptées. Nos experts vous aident à choisir la solution la plus pertinente.
          </p>
          <p>
            Nos formations sont 100 % accompagnées : vous vous concentrez sur votre formation tandis que nous nous occupons de toutes les démarches administratives et financières.
          </p>
        </div>

        {/* Colonne droite : Comment procéder */}
        <div className="col-md-6">
          <h2 className="fw-bold mb-4">Comment procéder ?</h2>
          <ul className="list-unstyled">
            {[
              "Prenez contact avec CO2 FORMATION.",
              "Un conseiller prend en charge votre demande.",
              "Le service administratif vous envoie le formulaire de prise en charge ainsi que la convention de formation pré-remplis.",
              "Vous signez et transmettez votre dossier à votre OPCO, accompagné du programme de formation et/ou du devis.",
              "Sous un mois maximum, votre OPCO nous retourne l’accord de prise en charge.",
              "Votre formation peut commencer dans les délais convenus."
            ].map((step, index) => (
              <li key={index} className="d-flex align-items-start mb-3">
                <span className="d-inline-flex align-items-center justify-content-center rounded-circle text-white fw-bold me-3" style={{ width: "40px", height: "40px", backgroundColor: "#6f42c1" }}>
                  {index + 1}
                </span>
                <p className="m-0">{step}</p>
              </li>
            ))}
          </ul>
        </div>

      </div>
    </div>
  );
};

export default FinancingSection;
